<div class="banerTokenPayment">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-6 mb-2 pl-0">
          <div class="row mb-2 pl-3">
            <div class="col-md-12 d-flex align-items-center">
              <b class="font-ac securityPaymentInformation" style="color: red;">100% Secure Payment!</b>
              <div class="d-flex align-items-center pl-3"> <b style="font-size:12px">Secured By:</b></div>
              <div class="pl-3" style="padding-left:15px">
                <img src="/images/authorizenet.png">
              </div>
            </div>
          </div>
          <div class="row pl-3">
            <div class="col-12 mb-2" style="font-size: 14px">
              <b>Charge will appear on your credit card statement as "Armax Technology"</b>
            </div>
          </div>
          <div class="col-md-12">
            <mat-form-field class="w-100">
              <input type="text" formControlName="firstName"
                     matInput
                     placeholder="First name *" />
              <mat-error *ngIf="form.controls['firstName'].hasError('required')">
                Required field
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field class="w-100">
              <input type="text" formControlName="lastName"
                     matInput
                     placeholder="Last name *" />
              <mat-error *ngIf="form.controls['lastName'].hasError('required')">
                Required field
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field class="w-100">
              <input type="text" formControlName="zip"
                     matInput
                     placeholder="Zip Code *" />
              <mat-error *ngIf="form.controls['zip'].hasError('required')">
                Required field
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field class="w-100">
              <input formControlName="creditCard"
                     matInput
                     placeholder="Credit Card *"
                     id="cc-number"
                     type="tel"
                     autocomplete="cc-number"
                     ccNumber />
              <mat-error *ngIf="form.controls['creditCard'].hasError('ccNumber')">
                Please enter a valid credit card number.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="row pr-3 m-0">
            <div class="col-md-12">Expiration Date:</div>
            <div class="col-md-5">
              <mat-form-field class="w-100">
                <input formControlName="expirationDateMonth"
                       matInput
                       placeholder="MM*"
                       id="cc-exp-date-m"
                       type="tel" />
                <mat-error *ngIf="
                      form.controls['expirationDateMonth'].hasError('required')
                    ">
                  Please enter a valid expiration date - MM
                </mat-error>
              </mat-form-field>
            </div>
            <div class="p-0 col-md-1 pt-3">
              /
            </div>
            <div class="col-md-5 p-0">
              <mat-form-field class="w-100">
                <input formControlName="expirationDateYear"
                       matInput
                       placeholder="YYYY*"
                       id="cc-exp-date-y"
                       type="tel" />
                <mat-error *ngIf="
                      form.controls['expirationDateYear'].hasError('required')
                    ">
                  Please enter a valid expiration date - YYYY
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-md-12">
            <mat-form-field class="w-100">
              <input formControlName="cvc"
                     matInput
                     placeholder="CVC *"
                     id="cc-cvc"
                     type="tel"
                     autocomplete="off"
                     ccCVC />
              <mat-error *ngIf="form.controls['cvc'].hasError('required')">
                Please enter a CVC number
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">Baner Link:</div>
          <div class="col-md-12">
            <mat-form-field class="w-100">
              <input type="text" formControlName="banerUrl"
                     matInput
                     placeholder="http://..." />
              <mat-error *ngIf="form.controls['banerUrl'].hasError('required')">
                Required field
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-12">
            Select Baner platform:
            <mat-radio-group (change)="changeBanerPlatform($event)">
              <mat-radio-button class="inline-radio mr-4" [checked]="banerPlatform == 0" [value]="0" >Desktop</mat-radio-button>
              <mat-radio-button class="inline-radio" [checked]="banerPlatform == 1" [value]="1" >Mobile</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div class="choose-file p-0" *ngIf="!isBanerMobile()">
        <h4>Choose baner image file (we only accept 160x600 and 728x90 image resolution) </h4>
        <div class="d-flex mb-3 align-items-center flex-wrap">
          <div class="banerTokenPayment__banerImage pt-0 pr-0" [ngClass]="{'choosen' :  selectedImages[0]}">
            <div
                 *ngIf="selectedImages[0]"
                 class="w-100 _h-100 selected-image-holder m-0"
                 [style.backgroundImage]="'url(' + selectedImages[0].imageUrl + '/800x600)'"></div>
            <div *ngIf="!selectedImages[0]" class="w-100 h-100 selected-image-holder placeholder-image m-0"></div>
          </div>
          <label class="mb-0">160x600:</label>
          <input id="desktopBanerFile-vertical"
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                required
                [uploadInputFor]="This" [inputId]="0"/>
        </div>
        <div class="d-flex mb-3 align-items-center flex-wrap">
          <div class="banerTokenPayment__banerImage pt-0 pr-0" [ngClass]="{'choosen' :  selectedImages[0]}">
            <div
                 *ngIf="selectedImages[1]"
                 class="w-100 _h-100 selected-image-holder m-0"
                 [style.backgroundImage]="'url(' + selectedImages[1].imageUrl + '/800x600)'"></div>
            <div *ngIf="!selectedImages[1]" class="w-100 h-100 selected-image-holder placeholder-image m-0"></div>
          </div>
          <label class="mb-0">728x90:&nbsp;&nbsp;</label>
          <input id="desktopBanerFile-horizontal"
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                required
                [uploadInputFor]="This" [inputId]="1"/>
        </div>
      </div>

      <div class="choose-file p-0" *ngIf="isBanerMobile()">
        <h4>Choose baner image file (we only accept 300x100 image resolution) </h4>
        <div class="d-flex mb-3 align-items-center flex-wrap">
          <div class="banerTokenPayment__banerImage pt-0 pr-0" [ngClass]="{'choosen' :  selectedImages[0]}">
            <div
                 *ngIf="selectedImages[2]"
                 class="w-100 _h-100 selected-image-holder m-0"
                 [style.backgroundImage]="'url(' + selectedImages[2].imageUrl + ')'"></div>
            <div *ngIf="!selectedImages[2]" class="w-100 h-100 selected-image-holder placeholder-image m-0"></div>
          </div>
          <label class="mb-0">300x100:</label>
          <input id="desktopBanerFile-vertical"
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                required
                [uploadInputFor]="This" [inputId]="2"/>
        </div>
      </div>

      <div class="banerTokenPayment__checkBox">
        <mat-checkbox required (change)="termsAcceptAction($event)">
          By checking this box I acknowledge that Wickedlist.com does not give me any assurance that my ROI(return on investment) will be higher than my actual investment!
        </mat-checkbox>
      </div>

      <div class="row mt-2 m-0" *ngIf="payButtonText != ''">
        <div class="col-12 m-0">
          <button class="w-100 create-button p-1"
                  mat-flat-button
                  color="primary"
                  type="submit">
            <span *ngIf="!creating">
              {{payButtonText}}
            </span>
            <mat-spinner *ngIf="creating" diameter="30"></mat-spinner>
  
          </button>
  
        </div>
        <div class="col-12 m-0 text-right">
          * No monthly subscriptions
        </div>
      </div>
    </form>
  </div>
  